import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80471154"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "white-card" }
const _hoisted_2 = { class: "white-card__container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "white-card__title" }, "Рекомендации", -1))
const _hoisted_4 = { class: "white-card__content" }
const _hoisted_5 = { class: "white-card__list" }
const _hoisted_6 = { class: "white-card__text white-card__row" }
const _hoisted_7 = { class: "white-card__footer" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Изменить ")

import { computed } from 'vue'
import { declination } from '@/shared/utils'
import { useOrganizationModules } from '@/shared/composables'
import { ScreeningControllerInterface } from '@/pages/ScreeningPage/screeningController'

interface Props {
  screeningController: ScreeningControllerInterface
}


export default /*#__PURE__*/_defineComponent({
  props: {
    screeningController: null
  },
  setup(__props: any) {

const props = __props as {
  screeningController: ScreeningControllerInterface
}



const signature = computed(() =>
  declination(props.screeningController.reCleaning, [
    'месяц',
    'месяца',
    'месяцев',
  ])
)

const { organizationModules } = useOrganizationModules()

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ol", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.screeningController.recommendations, (recommendation, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "white-card__text"
            }, _toDisplayString(recommendation), 1))
          }), 128))
        ]),
        _createElementVNode("p", _hoisted_6, [
          _createTextVNode(_toDisplayString(__props.screeningController.recommendations.length + 1) + ". Следующая профессиональная гигиена зубов через ", 1),
          _createVNode(_component_el_select, {
            modelValue: __props.screeningController.reCleaning,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.screeningController.reCleaning) = $event)),
            class: "el-input--screening",
            size: "small"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (item) => {
                return _createVNode(_component_el_option, {
                  key: item,
                  value: item
                }, null, 8, ["value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createTextVNode(" " + _toDisplayString(_unref(signature)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_button, {
        disabled: _unref(organizationModules).indexOf('screening') <= -1,
        class: "el-button--screening",
        round: "",
        type: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('updateReport')))
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})